import { Drawer } from "antd";
import { useMediaQuery } from "react-responsive";

import { Button } from "components/Button";
import "./filterControls.css";

// The frame every filter drawer shares: title with active count, sectioned
// body, and a footer with Clear all + Apply. Children are FilterSections.
const FilterDrawerShell = ({
  open,
  onClose,
  activeCount = 0,
  onClearAll,
  onApply,
  applying = false,
  applyDisabled = false,
  children,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <Drawer
      className="filter-drawer"
      title={
        <span className="filter-drawer__title">
          Filters
          {activeCount > 0 && (
            <span className="filter-section__count" aria-label={`${activeCount} active`}>
              {activeCount}
            </span>
          )}
        </span>
      }
      placement="right"
      width={isMobile ? "100%" : 440}
      closable={true}
      onClose={onClose}
      open={open}
      footer={
        <div className="filter-drawer__footer">
          <Button
            label="Clear all"
            onClick={onClearAll}
            disabled={activeCount === 0}
            className="btn btn-link p-0"
            style={{ color: activeCount ? "var(--brand-text-muted)" : "#d1d5db", fontWeight: 600 }}
          />
          <Button
            label="Apply Filter"
            loading={applying}
            disabled={applying || applyDisabled}
            onClick={onApply}
            className="btn btn-primary"
            style={{ borderRadius: "8px" }}
          />
        </div>
      }
    >
      {children}
    </Drawer>
  );
};

export default FilterDrawerShell;
